import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            探索视频分类
          </h2>
          <p className="text-foreground-500 max-w-lg mx-auto text-sm md:text-base">
            六大精选分类，帮你快速找到最喜欢的猫咪视频内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300">
                <i className={`text-xl md:text-2xl ${
                  ['ri-emotion-laugh-line', 'ri-sun-line', 'ri-film-line', 'ri-heart-pulse-line', 'ri-seedling-line', 'ri-book-open-line'][index]
                }`}></i>
              </div>
              <span className="font-heading text-sm md:text-base font-bold text-foreground-700 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed hidden sm:block">
                {cat.description.length > 24 ? cat.description.slice(0, 24) + '...' : cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}